import React, { useState, useEffect } from 'react';
import useAsync from '../hooks/useAsync';
import FeedbackServices from '../services/FeedbackServices';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import ViewFeedback from './View Model/ViewFeedback';
import ReactPaginate from 'react-paginate'; 
import { FaRegEye } from "react-icons/fa";

Modal.setAppElement('#root');

function Feedback() {
  const { data, error, isLoading, run } = useAsync(FeedbackServices.getAllReviews);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [ratingFilter, setRatingFilter] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10; 


  useEffect(() => {
    if (data?.data) {
      const filtered = data.data.vendors.filter(feedback => {
        const name = feedback?.user?.name?.toLowerCase() || '';
        const comment = feedback?.comment?.toLowerCase() || '';
        const mobileNo = feedback?.user?.mobileNo?.toString() || '';
        const matchesSearch = name.includes(searchTerm.toLowerCase()) ||
          comment.includes(searchTerm.toLowerCase()) ||
          mobileNo.includes(searchTerm);
        const matchesRating = ratingFilter ? feedback.rating === parseInt(ratingFilter) : true;
        return matchesSearch && matchesRating;
      });

      setFilteredData(filtered);
      setCurrentPage(0); 
    }
  }, [data, searchTerm, ratingFilter]);


  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };



  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleRatingFilterChange = (event) => {
    setRatingFilter(event.target.value);
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };


  const handleViewRating = (vendorId) => {
    if (vendorId) {
      window.location.href = `/vendor-wise-review?vendorId=${vendorId}`;
    }
  };


  const paginatedData = filteredData.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);


  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

          <div className="my-auto">

            <h5 className="page-title fs-21 mb-1">
              Vendor Feedback List <span className="badge bg-orange">{filteredData.length}</span>  </h5>
            <nav>

              <ol className="breadcrumb mb-0">

                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                Vendor Feedback
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
          </div>
        </div>

        <div className="container-box px-0">
          <div className="container-box-inner table-reponsive-tabe">
            <table id="example" className="table table-striped" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>VENDOR NAME</th>
                  <th>VENDOR MOBILE</th>
                  <th>TOTAL REVIEW</th>
                  <th>AVERAGE RATING</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              {paginatedData.length > 0 ? (
                <tbody>
                  {paginatedData.map((feedback, index) => (
                    <tr key={index}>
                      <td>{currentPage * itemsPerPage + index + 1}</td>
                      <td>{`${feedback?.name || "N/A"}`.trim() || "N/A"}</td>
                      <td>{feedback?.mobileNo}</td>
                      <td>{feedback?.totalReviews}</td>
                      <td>{feedback?.averageRating}</td>

                      <td
                        onClick={() => handleViewRating(feedback?._id)}
                        className="view-cities-button"
                        data-tooltip-id="view-cities-tooltip"
                        data-tooltip-content=" View Pincode"
                      >
                      
                      {/* <td  onClick={() => window.location.href = `/vendor-wise-review/${feedback?._id}`} className="view-cities-button"
                        data-tooltip-id="view-cities-tooltip"> */}
                      <FaRegEye className="custom-icon" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <tr><td colSpan="9">No Feedback Found</td></tr>
                </tbody>
              )}
            </table>
          </div>
         
          <ReactPaginate
            previousLabel={'<<'}
            nextLabel={'>>'}
            breakLabel={'...'}
            pageCount={Math.ceil(filteredData.length / itemsPerPage)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageChange}
            containerClassName={'pagination'}
            activeClassName={'active'}
            pageClassName={'page-item'}
            previousClassName={'page-item'}
            nextClassName={'page-item'}
            breakClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousLinkClassName={'page-link'}
            nextLinkClassName={'page-link'}
            breakLinkClassName={'page-link'}
          />
        </div>

        <Modal
          isOpen={isEditModalOpen}
          onRequestClose={closeEditModal}
          contentLabel="User Details"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <ViewFeedback feedback={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
        </Modal>
        <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeDeleteModal}
          contentLabel="Delete Confirmation"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <DeleteButton data={selectedEdit} page="feedback" closeModal={closeDeleteModal} onSuccess={run} />
        </Modal>


      </div>
    </>
  );
}

export default Feedback;
